import React from 'react';
import PropTypes from 'prop-types';
import { useSoyuzClientConfig, useSoyuzLocales } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

import { HeaderContainer as HeaderContainerComponent } from '@spotahome/ui-library';

import { useLocaleChange } from '../hooks/useLocaleChange';

import { getLoggedInUserInfo } from '../api/auth-client';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
} from '../api/traditional-login-client';

import { TOKEN_EXPIRED } from '../utils/channels';

const SESSION_EXPIRED_STATUS = 401;

const traditionalSignupCB = locale => (name, email, password) =>
  traditionalSignup({ name, email, password, locale });

const traditionalLoginCB = (email, password) =>
  traditionalLogin({ email, password });

const traditionalForgotPasswordCB = async email => {
  try {
    await traditionalForgotPassword({ email });
  } catch (err) {
    console.log(err);
  }
};

async function requestLoggedInUserInfo() {
  try {
    const response = await getLoggedInUserInfo();
    return response;
  } catch (err) {
    if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
      Mediator.publish(TOKEN_EXPIRED);
      return null;
    }
    throw new Error(err);
  }
}

const HeaderContainer = props => {
  const clientConfig = useSoyuzClientConfig();
  const handleOnLocaleChange = useLocaleChange();
  const { current } = useSoyuzLocales();

  return (
    <HeaderContainerComponent
      transparent
      color={props.color}
      locales={{ current, onChange: handleOnLocaleChange }}
      localeToggle={{ chinese: clientConfig.featureToggle.chinese }}
      login={{
        getLoggedInUserInfo: requestLoggedInUserInfo,
        modalProps: {
          traditionalSignupCB: traditionalSignupCB(current),
          traditionalLoginCB,
          forgotPasswordCB: traditionalForgotPasswordCB
        }
      }}
      {...props}
    />
  );
};

HeaderContainer.defaultProps = {
  color: 'dark'
};

HeaderContainer.propTypes = {
  color: PropTypes.string
};

export default HeaderContainer;
